import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PdfMergeNotificationCardModel } from './pdf-merge-notification-card.model';
import { JobNotificationCardComponent } from '../job-notification-card.component';
import { PrintActionButtonsComponent } from '../../../action-buttons/print-action-buttons/print-action-buttons.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-pdf-merge-notification-card',
  styleUrls: ['./pdf-merge-notification-card.component.scss'],
  templateUrl: './pdf-merge-notification-card.component.html',
  imports: [JobNotificationCardComponent, PrintActionButtonsComponent],
})
export class PdfMergeNotificationCardComponent {
  @Output() public closeEvent = new EventEmitter<void>();
  @Output() public downloadMergedPdfButtonEvent = new EventEmitter<void>();
  @Output() public downloadZipButtonEvent = new EventEmitter<void>();
  @Output() public openMergedPdfButtonEvent = new EventEmitter<void>();
  @Input() public pdfMergeNotification: PdfMergeNotificationCardModel;

  public downloadPdfButtonClickedHandler(): void {
    this.downloadMergedPdfButtonEvent.emit();
  }

  public downloadZipButtonClickedHandler(): void {
    this.downloadZipButtonEvent.emit();
  }

  public onCloseClickedHandler(): void {
    this.closeEvent.emit();
  }

  public openPdfButtonClickedHandler(): void {
    this.openMergedPdfButtonEvent.emit();
  }
}
